import React from "react";

const RequiredIndicator = props => {
	const { disabled } = props;
	const css = disabled ? "gray-600" : "text-danger";

	return <span className={css}>•</span>;
};

RequiredIndicator.defaultProps = {
	disabled: false
};

export default RequiredIndicator;
